import { IConfig } from '@cian/config/shared';
import { IAbExperimentsState } from '../../../shared/redux/reducers';

interface IParams {
  config: IConfig;
  abExperiments: IAbExperimentsState;
  search: string;
  isAddJKState: boolean;
}

export const getIsNewPublishTermsEnabled = (params: IParams): boolean => {
  const { config, abExperiments, search, isAddJKState } = params;

  if (isAddJKState) {
    return false;
  }

  // Фиче-тогл включён
  const isEnabled = config.get<boolean>('isNewPublishTerms.Enabled') || false;
  // Пользователь из списка
  const isAvailable = config.get<boolean>('isNewPublishTermsAvailable') || false;
  // Пользователь из группы
  const isInExperiment = abExperiments.ha387_newPublishTerms === '1';
  // Параметр в урле
  const isQASearchParamExist = search.includes('qaNewPublishTerms');

  return isQASearchParamExist || isEnabled && (isAvailable || isInExperiment);
};
